import { render, staticRenderFns } from "./TkStickyItem.vue?vue&type=template&id=52be2b62&scoped=true&"
import script from "./TkStickyItem.vue?vue&type=script&lang=js&"
export * from "./TkStickyItem.vue?vue&type=script&lang=js&"
import style0 from "./TkStickyItem.vue?vue&type=style&index=0&id=52be2b62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be2b62",
  null
  
)

export default component.exports